import React from 'react';
import { CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const EmailConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    emailRecipient,
    setEmailRecipient,
    ccRecipients,
    setCcRecipients,
    isSendingEmail,
    emailSent
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[999999]">
            <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                <div className="p-6">
                    <div className="flex justify-content-between align-items-center mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">Send Interview Feedback</h3>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                            disabled={isSendingEmail}
                        >
                            <CloseIcon size={20} />
                        </button>
                    </div>

                    {emailSent ? (
                        <div className="text-center py-8">
                            <div className="mb-4">
                                <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                                    <span className="text-2xl">✅</span>
                                </div>
                            </div>
                            <h3 className="text-lg font-semibold text-green-800 mb-2">Email Sent Successfully!</h3>
                            <p className=" text-gray-600">
                                The interview feedback has been sent to {emailRecipient?.email}
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className="bg-gray-50 rounded-lg p-4 mb-4">
                                <div className="mb-3">
                                    <div className=" text-gray-600 mb-1">Recipient Name</div>
                                    <div className=" text-gray-900">{emailRecipient?.name}</div>
                                </div>
                                <div className="mb-3">
                                    <div className=" text-gray-600 mb-1">Email Address</div>
                                    <input
                                        type="email"
                                        value={emailRecipient?.email || ''}
                                        onChange={(e) => setEmailRecipient(prev => ({ ...prev, email: e.target.value }))}
                                        placeholder="Enter recipient email address"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all   text-gray-900"
                                        disabled={isSendingEmail}
                                    />
                                </div>
                                <div>
                                    <div className=" text-gray-600 mb-1">CC Recipients</div>
                                    <input
                                        type="text"
                                        value={ccRecipients}
                                        onChange={(e) => setCcRecipients(e.target.value)}
                                        placeholder="Enter email addresses (comma-separated)"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all "
                                        disabled={isSendingEmail}
                                    />
                                    <p className=" text-gray-500 mt-1">Separate multiple email addresses with commas</p>
                                </div>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-3 mb-6">
                                <div className=" text-blue-900  mb-2">Email will include:</div>
                                <ul className=" text-blue-800 space-y-1">
                                    <li>• Interview feedback summary</li>
                                    <li>• Overall score and category scores</li>
                                    <li>• Question & answer pairs with scores</li>
                                    {emailRecipient?.htmlContent ? (
                                        <li className="text-green-700 ">• ✅ PDF report attachment</li>
                                    ) : (
                                        <li className="text-amber-700">• ⚠️ PDF report (generation failed)</li>
                                    )}
                                </ul>
                            </div>

                            <div className="flex gap-3">
                                <button
                                    onClick={onClose}
                                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors "
                                    disabled={isSendingEmail}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={onConfirm}
                                    disabled={isSendingEmail || !emailRecipient?.email}
                                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors  flex items-center justify-center gap-2"
                                >
                                    {isSendingEmail ? (
                                        <>
                                            <CircularProgress size={16} sx={{ color: 'white' }} />
                                            Sending...
                                        </>
                                    ) : (
                                        'Send Email'
                                    )}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EmailConfirmModal;